import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import { pushWishlistEvent } from '../../../data-layer/wishlist.js';
import { useRemoveFromShoppinglist } from '../../../hooks/use-remove-from-shopping-list.js';
import { useWishlistAuthState } from '../../../hooks/use-wishlist-auth-state.js';
import AnonymousWishlist from './AnonymousWishlistOverview.js';
import UserWishlistOverview from './UserWishlistOverview.js';

const WishlistContainer = ()=>{
    const { isAuthLoading , isUserLoggedIn  } = useWishlistAuthState();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const { localWishlist , clearWishlist  } = useWishlistId();
    const { loading: isUpdateLoading , removeFromShoppinglist , error ,  } = useRemoveFromShoppinglist({
        onCompleted: (data)=>{
            // If the mutation "succeeds", the BE can technically still send back a failure in the response
            // and a 200. This is why we need to check if the modifying is actually there.
            // In case of a failure the shopping list will be null.
            if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistSuccessResponse') {
                var ref;
                toast.success('account.wishlist.remove.success');
                /*
          If the wishlist is empty after removing an item (i.e. mutating the list),
          we need to remove the list from local storage to prevent modifying an empty
          list with the same id.
        */ if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistSuccessResponse' && !((ref = data.removeFromShoppinglist.result) === null || ref === void 0 ? void 0 : ref.items.length)) {
                    clearWishlist();
                }
            }
        },
        onError: ()=>{
            toast.failed('account.wishlist.remove.error');
        }
    });
    const handlePushWishlistEvent = React.useCallback((sku)=>{
        pushWishlistEvent({
            siteFeature: 'my_account',
            interactionType: 'wishlist_remove_item_click',
            messageType: error ? 'error' : 'item_removed',
            item: {
                sku
            }
        });
    }, [
        error
    ]);
    const onUpdateWishList = (sku, wishlistId)=>{
        handlePushWishlistEvent(sku);
        removeFromShoppinglist([
            sku
        ], wishlistId);
    };
    return !isAuthLoading && isUserLoggedIn ? /*#__PURE__*/ React.createElement(UserWishlistOverview, {
        isUpdateLoading: isUpdateLoading,
        onUpdateWishList: onUpdateWishList
    }) : /*#__PURE__*/ React.createElement(AnonymousWishlist, {
        isMyAccountEnabled: isMyAccountEnabled,
        isUpdateLoading: isUpdateLoading,
        isAuthLoading: isAuthLoading,
        onUpdateWishList: onUpdateWishList,
        localWishlistId: localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id,
        clearLocalWishlist: clearWishlist
    });
};

export { WishlistContainer as default };
//# sourceMappingURL=WishlistOverviewContainer.js.map
